import { requests, mainApiRoot } from './index'

export const Lists = {
  getAll: () => requests.get(mainApiRoot, '/lists/'),
  get: id => requests.get(mainApiRoot, `/lists/${id}`),
  create: payload => requests.post(mainApiRoot, '/lists/', { list: payload }),
  update: (id, payload) => requests.put(mainApiRoot, `/lists/${id}`, { list: payload }),
  del: id => requests.del(mainApiRoot, `/lists/${id}`),
  deleteKeywords: (id, keywordIds) =>
    requests.put(mainApiRoot, `/lists/${id}`, {
      list: {
        remove_keyword_info_uuids: keywordIds
      }
    }),
  export: id => requests.getFile(mainApiRoot, `/lists/${id}/csv`)
}
